module.exports = __webpack_public_path__ + "img/customer-contact-checked.fec8c173.svg";